const month = [];
month[0] = 'January';
month[1] = 'February';
month[2] = 'March';
month[3] = 'April';
month[4] = 'May';
month[5] = 'June';
month[6] = 'July';
month[7] = 'August';
month[8] = 'September';
month[9] = 'October';
month[10] = 'November';
month[11] = 'December';

const getDateString = (val) => {
  const newDate = new Date(Date.parse(val));
  return `${newDate.getDate()} ${month[newDate.getMonth()]}, ${newDate.getFullYear()}`;
};

export default getDateString;
